import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.activeUploads = 0;
  }

  uploadStarted(event) {
    this.activeUploads += 1;

    this.submitTarget.disabled = true;
  }

  uploadFinished(event) {
    this.activeUploads -= 1;

    if (this.activeUploads === 0) {
      this.submitTarget.disabled = false;
    }
  }

}
